import styled from "styled-components";
import { COLORS } from "Styles/Constants";
import { IMAGES } from "Helpers";

export const Toolbar = styled.div`
	box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
	background: #efefef;
	bottom: 0;
	left: 0;
	padding: 10px;
	position: fixed;
`;

export const Tool = styled.div`
	align-items: center;
	border: 3px solid transparent;
	border-radius: 3px;
	display: flex;
	justify-content: center;
	height: 50px;
	width: 50px;
	transition: 0.3s;

	&:hover {
		border-color: ${COLORS.PRIMARY};
	}

	${(props) => (props.active ? `border-color : ${COLORS.PRIMARY};` : "")}
`;
export const PadLockWrapper = styled.div`
	padding: 30px;
	background-color: #000;
	opacity: 0.5;
	border-radius: 20px;

	.lock-root {
		border: 2px solid #ff0006;
		color: #fff;
		padding: 0 10px;
	}
`;

export const PadLockDigitWrapper = styled.div`
	position: absolute;
	right: 40%;
	top: 40%;
	background-color: black;
	border-radius: 10px;
	opacity: 0.8;
	width: 330px;
	height: max-content;

	.digit {
		display: flex;
		justify-content: center;
		padding: 15px;
		font-size: 24px;
		color: #fff;
	}

	.section {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-evenly;

		.card {
			width: 100px;
			height: 100px;
			border-radius: 10px;
			margin: 5px;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #5b9bd5;
			color: #fff;
			cursor: pointer;
		}
	}
`;

export const ModalWrapper = styled.div`
	position: absolute;
	right: 30%;
	top: 20%;
	/* background-color : black; */
	border-radius: 10px;
	/* opacity : 0.8; */
	height: max-content;

	.section {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-evenly;

		.card {
			width: 500px;
			border-radius: 4px;
			margin: 5px;
			display: flex;
			align-items: center;
			justify-content: center;
			/* background-color : #5b9bd5; */
			color: #fff;
			cursor: pointer;
		}
	}
`;

export const CryptLockWrapper = styled.div`
	position: absolute;
	right: 30%;
	top: 50%;
	background-color: black;
	border-radius: 10px;
	opacity: 0.8;
	width: 230px;
	height: max-content;

	.section {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-evenly;

		.card {
			width: 50px;
			height: 50px;
			border-radius: 10px;
			margin: 5px;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #5b9bd5;
			color: #fff;
			cursor: pointer;
		}
	}
`;

export const DesignWrapper = styled.div`
	position: absolute;
	right: 30%;
	top: 20%;
	border-radius: 10px;
	height: max-content;

	.clue-content {
		font-size: 18px;
	}

	.button-wrapper {
		position: absolute;
		bottom: -22px;
		text-align: center;
	}
`;

export const WelcomeWrapper = styled.div`
	position: absolute;
	right: 34%;
	top: 20%;
	border-radius: 10px;
	height: max-content;

	.clue-content {
		font-size: 18px;
	}

	.button-wrapper {
		position: absolute;
		bottom: -22px;
		text-align: center;
	}
`;

export const ClueWrapper = styled.div`
	.clue-image {
		background-image: url(${IMAGES.CIVICS.ESCAPE_ROOM.CLUE_BUTTON});
		background-repeat: no-repeat;
		width: 100px;
		height: 100px;
		position: absolute;
		background-size: 100% 100%;
		bottom: 7px;
		right: 14px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		.text {
			color: #000;
			font-size: 18px;
			font-weight: 600;
		}

		.timer {
			color: #000;
			font-size: 22px;
			font-weight: 600;
		}

		.progress {
			width: 106px !important;
			height: 106px !important;
			color: #000;
		}
	}
	.skip-to-login {
		position: absolute;
		background-size: 100% 100%;
		bottom: 40px;
		left: 14px;
		cursor: pointer;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-align-items: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
	}
`;
